/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import AppContainer from "../Components/Structure/AppContainer";
import { Toaster } from "react-hot-toast";
import SchoolTwilioLogs from "../Components/CallLogs/SchoolTwilioLogs";
import SchoolZegoLogs from "../Components/CallLogs/SchoolZegoLogs";
import SchoolContext from "../Context/SchoolContext";
import ajaxCallStation from "../util/remote/ajaxCallStation";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function SchoolCallLogsPage() {
  const { schoolDetails } = useContext(SchoolContext);
  const schoolID = schoolDetails.school_id;
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const todayFormatted = new Date().toLocaleDateString('en-US', options);
  const [schoolCallStatsToday, setSchoolCallStatsToday] = useState(false);
  const [schoolCallStatsOverall, setSchoolCallStatsOverall] = useState(false);

  useEffect(() => {
        getSchoolCallStatsOverall();
        getSchoolCallStatsToday();
  
    }, [schoolID]);

  const getSchoolCallStatsOverall = async () => {
      const server_response = await ajaxCallStation.schoolCallStatisticsOverall(schoolID);
      if (server_response.status === "OK") {
        setSchoolCallStatsOverall(server_response.details);
      } else {
        setSchoolCallStatsOverall(false);
      }
    };
  
    const getSchoolCallStatsToday = async () => {
      const server_response = await ajaxCallStation.schoolCallStatisticsToday(schoolID);
      if (server_response.status === "OK") {
        setSchoolCallStatsToday(server_response.details);
      } else {
        setSchoolCallStatsToday(false);
      }
    };
    
  return (
    <AppContainer title="School Logs">
      <Toaster position="top-center" reverseOrder={false} />
      
      <div className="row logtat">
            <div className="col-lg-12" style={{padding:0}}>
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body map-card gradient-my-blue">
                  <div className="item-title mb-2" style={{color:"white"}}><b>STATISTICS </b></div>
                  <div className="row">
                    <div className="col-xl-4 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{schoolCallStatsOverall ? schoolCallStatsOverall.totals.buzz_voice.total.total_p : "..."}</span></h2>
                        <p className="mb-0 text-light"> Buzz Voice Calls</p>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{schoolCallStatsOverall ? schoolCallStatsOverall.totals.buzz_video.total.total_p : "..."}</span></h2>
                        <p className="mb-0 text-light"> Buzz Video Calls</p>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-12 col-sm-6 pr-0 pl-0">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{schoolCallStatsOverall ? schoolCallStatsOverall.totals.gsm.total.total_p : "..."}</span></h2>
                        <p className="mb-0 text-light"> Direct Calls</p>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>                  
            </div>
          
      </div>
      
      <div className="row">
        <div className="col-lg-6">
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body map-card">
                  <div className="item-title">
                    <h5 style={{marginBottom:10}}>Statistics Today ({todayFormatted})</h5>
                  </div>
                  <div className="table-responsive">
                  <table className="table display data-table text-nowrap">
                    <tbody>
                    <tr>
                        <th>Call Type</th>
                        
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Completed</Tooltip>}>
                            <td ><i className="fa fa-square-check" style={{color: "green"}}></i></td></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Missed</Tooltip>}>
                        <td ><i className="fa fa-square-xmark" style={{color: "#DE3163"}}></i></td></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Total</Tooltip>}>
                        <th ><i className="fa fa-equals" ></i></th></OverlayTrigger>
                       
                      </tr>
                      <tr>
                        <td>Buzz Voice Calls</td>
                        <td >{schoolCallStatsToday ? schoolCallStatsToday.totals.buzz_voice.completed.total_p : "..."}</td>
                        <td >{schoolCallStatsToday ? schoolCallStatsToday.totals.buzz_voice.missed.total_p : "..."}</td>
                        <td >{schoolCallStatsToday ? schoolCallStatsToday.totals.buzz_voice.total.total_p : "..."}</td>
                        
                      </tr>
                      <tr>
                        <td>Buzz Video Calls</td>
                        <td >{schoolCallStatsToday ? schoolCallStatsToday.totals.buzz_video.completed.total_p : "..."}</td>
                        <td >{schoolCallStatsToday ? schoolCallStatsToday.totals.buzz_video.missed.total_p : "..."}</td>
                        <td >{schoolCallStatsToday ? schoolCallStatsToday.totals.buzz_video.total.total_p : "..."}</td>
                       
                      </tr>
                      <tr>
                        <td>Direct Calls</td>
                        <td >{schoolCallStatsToday ? schoolCallStatsToday.totals.gsm.completed.total_p : "..."}</td>
                        <td >{schoolCallStatsToday ? schoolCallStatsToday.totals.gsm.missed.total_p : "..."}</td>
                        <td >{schoolCallStatsToday ? schoolCallStatsToday.totals.gsm.total.total_p : "..."}</td>
                      </tr>
                      
                      
                    </tbody>
                  </table></div>
                </div>
              </div>
           
           
          
        </div>
        <div className="col-lg-6">
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body">
                  <div class="heading-layout1 mg-b-5">
                                     <div className="item-title">
                                      <h5 style={{marginBottom:10}}>Overall Call Statistics</h5>
                                    </div>
                         
                        </div>
                  <div className="table-responsive">
                  <table className="table display data-table text-nowrap">
                    <tbody>
                    <tr>
                        <th>Call Type</th>
                        
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Completed</Tooltip>}>
                            <td ><i className="fa fa-square-check" style={{color: "green"}}></i></td></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Missed</Tooltip>}>
                        <td ><i className="fa fa-square-xmark" style={{color: "#DE3163"}}></i></td></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Total</Tooltip>}>
                        <th ><i className="fa fa-equals" ></i></th></OverlayTrigger>
                        
                      </tr>
                      <tr>
                        <td>Buzz Voice Calls</td>
                        <td >{schoolCallStatsOverall ? schoolCallStatsOverall.totals.buzz_voice.completed.total_p : "..."}</td>
                        <td >{schoolCallStatsOverall ? schoolCallStatsOverall.totals.buzz_voice.missed.total_p : "..."}</td>
                        <td >{schoolCallStatsOverall ? schoolCallStatsOverall.totals.buzz_voice.total.total_p : "..."}</td>
                      
                      </tr>
                      <tr>
                        <td>Buzz Video Calls</td>
                        <td >{schoolCallStatsOverall ? schoolCallStatsOverall.totals.buzz_video.completed.total_p : "..."}</td>
                        <td >{schoolCallStatsOverall? schoolCallStatsOverall.totals.buzz_video.missed.total_p : "..."}</td>
                        <td >{schoolCallStatsOverall ? schoolCallStatsOverall.totals.buzz_video.total.total_p : "..."}</td>
                      </tr>
                      <tr>
                        <td>Direct Calls</td>
                        <td >{schoolCallStatsOverall ? schoolCallStatsOverall.totals.gsm.completed.total_p : "..."}</td>
                        <td >{schoolCallStatsOverall? schoolCallStatsOverall.totals.gsm.missed.total_p : "..."}</td>
                        <td >{schoolCallStatsOverall ? schoolCallStatsOverall.totals.gsm.total.total_p : "..."}</td>
                      </tr>
                      
                    </tbody>
                  </table></div>
                </div>
              </div>
            
           
         
         
        </div>
      </div>
      <div className="row">
      <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                  <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Row>
                      <Col sm={12}>
                        <Nav variant="pills" className="flex-row mb-1">
                          <Nav.Item>
                            <Nav.Link size="sm" eventKey="first">
                              Buzz to Buzz Calls{" "}
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link size="sm" eventKey="second">
                              Direct Calls{" "}
                            </Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </Col>
                      <Col sm={12}>
                        <Tab.Content>
                          <Tab.Pane eventKey="first">
                            <SchoolZegoLogs/>
                          </Tab.Pane>
                          <Tab.Pane eventKey="second">
                            <SchoolTwilioLogs/>
                          </Tab.Pane>
                        </Tab.Content>
                      </Col>
                    </Row>
                  </Tab.Container>  
                </div>
              </div>
          </div>
      </div>
    </AppContainer>
  );
}

export default SchoolCallLogsPage;
